// extracted by mini-css-extract-plugin
module.exports = {"moreAboutBrickxPropertiesContainer":"_1X7Hg","item":"_3a6eO","itemContainer":"_1iTxj","item__image":"dsjai","item__description":"_3EyvQ"};